import { Dispatch } from "redux";
import { getAxnAdminUserRequest } from "@requests/axnadmin-core";
import { AxnAdminUser } from "@idw-types/data/axn-admin-user";
import { setOrganizationUserDetails, setOrganizationUserDetailsLoading } from "@redux/actions/organization-user-details-actions";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const getOrganizationUserDetailsReduxRequest = (dispatch: Dispatch) => async (
    axnAdminUserId: string
): Promise<AxnAdminUser> => {
    dispatch(setOrganizationUserDetailsLoading(true));
    const { data, error } = await getAxnAdminUserRequest(axnAdminUserId);
    if (data) {
        dispatch(setOrganizationUserDetails(data));
        return data;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getOrganizationUserDetails.error.title,
                resources.requests.getOrganizationUserDetails.error.message
            );
        }
        dispatch(setOrganizationUserDetailsLoading(false));
        return null;
    }
};